//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class LetterCategoryService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[LetterCategory.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/letter-category/detail', {'params':params});
	};

	//GeneratorFlag:[LetterCategory.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/letter-category/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}